export default __webpack_public_path__ + "static/media/Cell-culture-bag.b37cf4ca.jpg";